export default __webpack_public_path__ + "static/media/snoopy_color.ef4d5125.png";